var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
export class ModelCommunityCollectionItem {
    author;
    author_id;
    cdate;
    comment;
    community_id;
    country;
    country_id;
    date;
    date_end;
    date_format;
    depository;
    depository_id;
    description;
    fileName;
    details;
    event_id;
    file_extension;
    folder_id;
    has_watermark;
    hash;
    id;
    isCleanup;
    is_converted;
    is_public;
    location;
    location_id;
    mdate;
    name;
    obj_type;
    orig_extension;
    original_id;
    path;
    physical_form_code;
    physical_form_description;
    physical_form_id;
    resolution;
    state;
    stockage;
    stockage_id;
    stockage_reference;
    stockage_reference_id;
    sub_type;
    sync_allow_change;
    sync_id;
    time;
    user_id;
    weight;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityCollectionItem.prototype, "depository", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityCollectionItem.prototype, "description", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => `${obj.name || ''}${obj.file_extension ? '.' + obj.file_extension : ''}`),
    __metadata("design:type", String)
], ModelCommunityCollectionItem.prototype, "fileName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityCollectionItem.prototype, "id", void 0);
